import AmazonWebServicesIcon from "../../../assets/amazon-web-services.png";
import DoitLogo from "../../../assets/doit-logo-hero-square.svg";
import DoitNavigatorIcon from "../../../assets/doit-navigator.svg";
import DoitOneTimeServiceFeeIcon from "../../../assets/doit-one-time-service-fee.svg";
import DoitSolveIcon from "../../../assets/doit-solve.svg";
import FlexsaveStandaloneIcon from "../../../assets/flexsave-logo-small.png";
import GSuiteIcon from "../../../assets/g-suite.png";
import GoogleCloudIcon from "../../../assets/google-cloud.png";
import GoogleLookerIcon from "../../../assets/google-looker.png";
import MicrosoftAzureIcon from "../../../assets/microsoft-azure.png";
import Office365Icon from "../../../assets/office-365.png";
import SuperQueryIcon from "../../../assets/superquery.png";

export const products = [
  {
    title: "Amazon Web Services",
    value: "amazon-web-services",
  },
  {
    title: "Google Cloud",
    value: "google-cloud",
  },
  {
    title: "Looker",
    value: "looker",
  },
  {
    title: "Google Workspace",
    value: "g-suite",
  },
  {
    title: "Standalone",
    value: "standalone",
  },
  {
    title: "Microsoft Azure",
    value: "microsoft-azure",
  },
  {
    title: "Office 365",
    value: "office-365",
  },
  {
    title: "superQuery",
    value: "superquery",
  },
  {
    title: "DoiT Navigator",
    value: "navigator",
  },
  {
    title: "DoiT Solve",
    value: "solve",
  },
  {
    title: "DoiT One-Time Service Fee",
    value: "doit-one-time-service-fee",
  },
  {
    title: "DoiT Cloud Intelligence",
    value: "doit-cloud-intelligence",
  },
  {
    title: "DoiT Cloud Intelligence Single Purchase",
    value: "doit-cloud-intelligence-sp",
  },
] as const;

export const standaloneProducts = ["google-cloud-standalone", "amazon-web-services-standalone"];

export const productIcon = (type: string) => {
  switch (type) {
    case "google-cloud":
      return GoogleCloudIcon;
    case "amazon-web-services":
      return AmazonWebServicesIcon;
    case "g-suite":
      return GSuiteIcon;
    case "office-365":
      return Office365Icon;
    case "microsoft-azure":
      return MicrosoftAzureIcon;
    case "superquery":
      return SuperQueryIcon;
    case "looker":
      return GoogleLookerIcon;
    case "standalone":
    case "google-cloud-standalone":
    case "amazon-web-services-standalone":
      return FlexsaveStandaloneIcon;
    case "navigator":
      return DoitNavigatorIcon as string;
    case "solve":
      return DoitSolveIcon as string;
    case "doit-one-time-service-fee":
      return DoitOneTimeServiceFeeIcon as string;
    case "doit-cloud-intelligence":
    case "doit-cloud-intelligence-sp":
      return DoitLogo as string;
    default:
      return "";
  }
};
